/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsChangeRetirementDate204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsChangeRetirementDate505Schema = z.any();

export const optionsChangeRetirementDateMutationResponseSchema = z.lazy(() => optionsChangeRetirementDate204Schema);
